import { fetchData } from '../fetchService';
import {
	AuthKeys,
	ApiKeyRequest,
	CreateApiKeyResponse,
	ListApiKeysResponse,
	ResponseWitOutData,
	GetListByPrincipalRequest,
} from '../types';
import { toSearchParams } from '../helpers/common';

const apiKeyService = {
	async create(
		baseUrl: string,
		principal: string,
		data: ApiKeyRequest,
		authKeys: AuthKeys,
	): Promise<CreateApiKeyResponse> {
		return await fetchData(
			`${baseUrl}/apikey?principal=${principal}`,
			'POST',
			data,
			authKeys,
		);
	},
	async getList(
		baseUrl: string,
		data: GetListByPrincipalRequest,
		authKeys: AuthKeys,
	): Promise<ListApiKeysResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/apikey/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
	async delete(
		baseUrl: string,
		principal: string,
		data: ApiKeyRequest,
		authKeys: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/apikey?principal=${principal}`,
			'DELETE',
			data,
			authKeys,
		);
	},
};

export default apiKeyService;
